export enum Gift {
  YES = 'YES',
  NO = 'NO',
  LATER = 'LATER'
}
